import { useEffect, useState } from "react";
import { api } from "../api/client";

/* The /vnc/ capture-browser iframe is gated by nginx on a cookie that only
   POST /api/vnc/pass (a logged-in Admin/SuperAdmin call) can set — see
   api/routers/vnc_auth.py. Fetch it before rendering the iframe; it lasts 4 h,
   so re-issue after 1 h to be safe on a long sitting. */

let issuedAt = 0;
let inflight: Promise<void> | null = null;

export function ensureVncPass(): Promise<void> {
  if (Date.now() - issuedAt < 60 * 60 * 1000) return Promise.resolve();
  if (!inflight) {
    inflight = api.post("/api/vnc/pass")
      .then(() => { issuedAt = Date.now(); })
      .finally(() => { inflight = null; });
  }
  return inflight;
}

/** true once the pass cookie is set (only asked for while `active`). */
export function useVncPass(active: boolean): { ready: boolean; error: string | null } {
  const [ready, setReady] = useState(Date.now() - issuedAt < 60 * 60 * 1000);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (!active) return;
    let live = true;
    ensureVncPass()
      .then(() => { if (live) { setReady(true); setError(null); } })
      .catch(() => { if (live) setError("could not authorise the live browser view — reload and try again"); });
    return () => { live = false; };
  }, [active]);
  return { ready, error };
}
